$(document).ready(function($) {
  var scrollDist = $(window).scrollTop();
  var distanceThreshold = 80;
  var $target = $("#MainHeader");

  checkDistance(scrollDist);
  
  $(window).scroll(function () {
      checkDistance($(window).scrollTop());
  });
  
  function checkDistance(scrollDist){
    if(scrollDist > distanceThreshold){
      dockHeader();
    }else{

      unDockHeader();
    }  
  }
  function dockHeader(){
    if(!$target.hasClass("dock-header")){
    	$target.addClass("dock-header");
  	}
  }
  function unDockHeader(){
  	if($target.hasClass("dock-header")){
    	$target.removeClass("dock-header");
	}
  }
  
});